import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

//  Services
import { AuthenticationService } from '../../services/authentication.service';
import { AbstractService } from '../../services/abstract.service';
import { ReviewerService } from '../../services/reviewer.service';

//  Libraries
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext } from 'angular2-modal/plugins/bootstrap';

export class ReviewersModalWindow extends BSModalContext {
    private id: number;
}

@Component({
    selector: 'view-reviewers-component',
    templateUrl: './viewReviewers.component.html',
    providers: []
})

export class ViewReviewersComponent implements ModalComponent<ReviewersModalWindow>, OnInit {

    modalContext: ReviewersModalWindow;
    isLoading = true;
    reviewers: any = [];

    constructor(
        private router: Router,
        private authService: AuthenticationService,
        private abstractService: AbstractService,
        private reviewerService: ReviewerService,
        public dialog: DialogRef<ReviewersModalWindow>) {

        this.modalContext = dialog.context;
        // this.modalContext.dialogClass = 'modal modal-lg';
    }

    ngOnInit() {

        this.reviewerService.getReviewers()
            .subscribe(reviewers => {
                this.reviewers = reviewers.aaData;
                this.isLoading = false;
            }, err => {
                // console.log(err);
                this.isLoading = false;
            });
    }

    selectReviewer(reviewer: any) {

        var currentSession = this.authService.retrieveSession();

        if (!currentSession) currentSession = {}; 

        currentSession.reviewer = {};
        currentSession.reviewer = reviewer;

        this.authService.storeSession(currentSession);

        this.close();
    }

    close() {
        this.dialog.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reviewer/viewReviewers.component.ts